import $ from 'jquery';

const Attr = {
  MODE: 'data-tn-tab-mode',
  CONTENT_ID: 'data-tn-tab-content-id',
};

const Key = {
  LEFT: 37,
  RIGHT: 39,
  UP: 38,
  DOWN: 40,
};

class TabNav {
  constructor(el, options = {}) {
    this.options = Object.assign({}, {
      onChange: null,
      activeClass: 'active',
      mode: null,
    }, options);

    this.init(el);
  }

  init(el) {
    this.modeMap = new Map();
    this.dataArray = [];
    this.mode = this.options.mode;

    this.$nav = $(el);
    this.$nav.attr('role', 'tablist');

    this.$tabs = this.$nav.find('li');
    this.$tabs.toArray().forEach((tab, index) => {
      const $tab = $(tab);
      const mode = $tab.attr(Attr.MODE);
      const tabId = $tab.attr('id');
      const contentId = $tab.attr(Attr.CONTENT_ID);
      const $target = $(`#${contentId}`).first();

      $tab.attr('aria-controls', contentId);
      $tab.attr('role', 'tab');

      $target.attr('aria-labelledby', tabId);
      $target.attr('role', 'tabpanel');

      const data = { $tab, $target, index };

      this.modeMap.set(mode, data); // To lookup by mode
      this.dataArray.push(data); // To lookup by index
    });

    this.$tabs.on('keydown', (event) => {
      const key = event.which;

      let mod = null;

      switch (key) {
        case Key.LEFT:
        case Key.UP:
          mod = -1;
          break;
        case Key.RIGHT:
        case Key.DOWN:
          mod = 1;
          break;
        default:
          return;
      }

      if (mod === null) {
        return;
      }

      event.preventDefault();
      const $tab = $(event.target);
      const mode = $tab.attr(Attr.MODE);

      const index = this.modeMap.get(mode).index; // this is super clunky - go off dom order?
      const numItems = this.dataArray.length;
      let newIndex = index + mod;
      if (newIndex === -1) {
        newIndex = numItems - 1;
      } else {
        newIndex %= numItems;
      }

      const $newTab = this.dataArray[newIndex].$tab;
      $newTab.focus();
      this.setCurrentTab($newTab);

    });

    this.$tabs.on('click', ({ currentTarget }) => {
      this.setCurrentTab(currentTarget);
    });

    this.$tabs.on('blur', ({ relatedTarget }) => {
      if (this.$nav[0].contains(relatedTarget) === false) {
        this.modeMap.forEach(({ $tab }, id) => {
          const isCurrent = id === this.mode;
          $tab.attr('tabindex', isCurrent ? 0 : -1);
        });
      }
    });

    // Activate either the specified mode:
    if (this.mode !== null) {
      this.setCurrentTab(this.modeMap.get(this.mode).$tab);
    } else {
      const $active = this.$tabs.filter(`.${this.options.activeClass}`);
      // The tab with an active class:
      if ($active.length) {
        this.setCurrentTab($active[0]);
      } else {
        // Or the first tab in the list:
        this.setCurrentTab(this.$tabs[0]);
      }
    }
  }

  setCurrentTab($newTab) {
    const mode = $($newTab).attr(Attr.MODE);

    this.mode = mode;

    const { activeClass, onChange } = this.options;

    this.modeMap.forEach(({ $tab, $target }, id) => {
      const isCurrent = id === this.mode;

      $tab.toggleClass(activeClass, isCurrent);
      $tab.attr('aria-selected', isCurrent);
      $tab.attr('tabindex', isCurrent ? 0 : -1);

      $target.attr('aria-hidden', !isCurrent);
      $target.css('display', isCurrent ? '' : 'none');
    });

    if (onChange) {
      onChange(this.mode);
    }
  }
}

export default TabNav;
